// core
import React from "react";
import QuoteCallToAction from "../../Components/QuoteCallToAction/QuoteCallToAction";
import Button from "../../../../../common/components/Forms/Button/Button";
import QuoteTableState from "../../../../types/quoteTable/IQuoteTableState";
import IQuoteCardResult from "../../../../interfaces/results/IQuoteCardResult";
import cx from "classnames";

// interfaces
interface IQuoteTableFooterContentProps {
    quoteState: QuoteTableState;
    // CTA
    handleSelectProduct: (isSelected: boolean) => Promise<void>;
    card: IQuoteCardResult;
    groupId: string;
    // View Switcher
    viewSwitcherText: string;
    onClickSwitchView: () => void;
    applicationURL: string;
    totalPremium: number;
}

// functions

// rendering
const QuoteTableFooterContent: React.FC<IQuoteTableFooterContentProps> = (props) => {
    const {
        quoteState,
        viewSwitcherText,
        onClickSwitchView,
        applicationURL,
        totalPremium,
        card,
        groupId
    } = props;


    return (
        <React.Fragment>
            <Button
                component="button"
                size="s"
                onClick={onClickSwitchView}
                variant="default"
                className={cx("gap-l", "btn-full-width")}
                isDisabled={quoteState.isDisabled}>
                {viewSwitcherText}
            </Button>

            {/* Call to action */}
            <QuoteCallToAction
                groupId={groupId}
                card={card}
                isDisabled={
                    quoteState.hasBlockingError ||
                    !quoteState.isOverMinimumPremium ||
                    quoteState.isDisabled
                }
                url={applicationURL}
                premium={totalPremium}
                className="btn-small"
            />
        </React.Fragment>
    );
};

export default React.memo(QuoteTableFooterContent);
